import { BaseRoutes } from '@monorepo/tools/src/lib/routes/base.routes';
import { AuthRoutes } from './auth.routes';
import { GeneralRoutes } from './general.routes';
import { AccountsRoutes } from './accounts.routes';
import { DestinationsRoutes } from './destinations.routes';
import { DomainMaxLossRoutes } from './domain-max-loss.routes';
import { KeysManagementRoutes } from './keys-management.routes';
import { BidderDomainsStatesRoutes } from './bidder-domains-states.routes';
import { BidderRoutes } from './bidder.routes';
import { BidderAdvertisersRoutes } from './bidder-advertisers.routes';
import { DomainOverlapRoutes } from './domain-overlap';
import { bidderChangesLogs } from './bidder-changes-logs.routes';

const routes = {
	domainFactors: new BaseRoutes('domain-factors'),
	reports: new BaseRoutes('reports'),
	campaigns: new BaseRoutes('campaigns'),
	preferences: new BaseRoutes('preferences'),
	creatives: new BaseRoutes('creatives'),
	creativeGroups: new BaseRoutes('creative-groups'),
	advertisers: new BaseRoutes('advertisers'),
	campaignGroups: new BaseRoutes('campaign-groups'),
	tests: new BaseRoutes('tests'),
	visualizer: new BaseRoutes('visualizer'),
	campaignConfigAudit: new BaseRoutes('configuration-audit'),
	deals: new BaseRoutes('deals'),
	domains: new BaseRoutes('domains'),
	jobs: new BaseRoutes('jobs'),
	tools: new BaseRoutes('tools'),
	bidder: new BidderRoutes(),
	bidderAdvertisers: new BidderAdvertisersRoutes(),
	bidderDomains: new BaseRoutes('bidder-domains-manager'),
	bidderDomainsStates: new BidderDomainsStatesRoutes(),
	domainOverlap: new DomainOverlapRoutes(),
	bidderChangesLogs: new bidderChangesLogs(),
	auth: new AuthRoutes(),
	keysManagement: new KeysManagementRoutes(),
	domainMaxLoss: new DomainMaxLossRoutes(),
	accounts: new AccountsRoutes(),
	destinations: new DestinationsRoutes(),
	general: new GeneralRoutes(),
};

export default routes;
